export default "__VITE_ASSET__17c2b6d6__"